import script from "./two.vue?vue&type=script&setup=true&lang=js"
export * from "./two.vue?vue&type=script&setup=true&lang=js"

import "./two.vue?vue&type=style&index=0&id=0c755d7a&lang=less"

const __exports__ = script;

export default __exports__